const LANGUAGE_PREFIX = /^\/(et|ru|en|he|iw)(?=\/|$)/;
const DEFAULT_LANGUAGE = "et";

export function stripLanguagePrefix(pathname = "") {
	const stripped = String(pathname).replace(LANGUAGE_PREFIX, "");
	return stripped === "" ? "/" : stripped;
}

export function withLanguagePrefix(path, language, defaultLanguage = DEFAULT_LANGUAGE) {
	const normalized = path && path.startsWith("/") ? path : `/${path || ""}`;
	if (!language || language === defaultLanguage) {
		return normalized;
	}
	if (normalized === "/") {
		return `/${language}/`;
	}
	return `/${language}${normalized}`;
}

export function isLoginPath(pathname) {
	const current = stripLanguagePrefix(pathname);
	return current === "/login" || current === "/login/";
}
